// extracted by mini-css-extract-plugin
export default {"formWrapper":"bank-detail-form_formWrapper__hFJYX","actionButtonWrapper":"bank-detail-form_actionButtonWrapper__S9hJa","actionWrapper":"bank-detail-form_actionWrapper__cP6xC"};